export default {
  'menu.CompaniesMapPage': '场所地图',
}